import { combineReducers } from 'redux';
import { getSuccessActionType } from '../utils';
import { getErrorReducer, getStatusReducer } from './utils/generators';
import { FETCH_STUDENT_DECK } from '../constants/student-deck';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_DECK):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_STUDENT_DECK]),
  error: getErrorReducer([FETCH_STUDENT_DECK]),
  data
});
